import * as React from 'react';
import { FieldsProps, formValueSelector } from 'redux-form';
import { Row, Col, Button } from 'react-bootstrap';
import { ITraveller } from '../../../../../../data/api/models';
import { finishScreening, startScreening } from '../../../../../../services/healix/reducer';
import Healix from '../../../Healix';
import { flow } from 'lodash';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {IStore} from '../../../../../../redux/IStore';

interface ITravellersMedicalProps {
  fields: FieldsProps<any>;
  change(field: string, value: any): void;
  setIsScreening(isScreening: boolean): void;
  travellers: ITraveller[];
  destinations: string[];
  region: string[];
  healix: any;
  dispatch();
  channel: any;
  startScreening(travellerIndex, screeningId, region, destinations, callback);
  finishScreening(callback);
}

interface ITravellersMedicalState {
  key: string | number;
  loading: boolean;
  sessionId: string;
  traveller: ITraveller;
  isScreening: boolean;
}

class TravellersMedical extends React.Component<ITravellersMedicalProps, ITravellersMedicalState> {
  public state = {
    key: null,
    loading: false,
    sessionId: null,
    traveller: null,
    isScreening: false,
  };

  private handleStartScreening = (traveller: ITraveller, key) => () => {
    this.setState({
      loading: true,
      traveller,
      key,
    });

    const { region, destinations, startScreening } = this.props;

    const hasConditions = traveller.screening && traveller.screening.meta.conditions.length > 0;

    startScreening(key, hasConditions ? traveller.screeningSessionId : null, region, destinations, (sessionId) => {
      this.props.setIsScreening(true);
      this.setState({
        loading: false,
        isScreening: true,
        sessionId,
      });
    });

  }

  private getTravellerIndex = (id: string, fields) => {
    let travellerIndex = -1;
    const travellers = fields.getAll();

    travellers.forEach((traveller, index) => {
      if (traveller.id === id) {
        travellerIndex = index;
      }
    });

    if (travellerIndex === -1) {
      console.error('Couldn\'t find traveller', travellers, id, travellerIndex);
    }

    return travellerIndex;
  }
  private handleFinishScreening = () => {
    const { change, finishScreening, fields } = this.props;
    const { /*sessionId,*/ traveller } = this.state;

    const key = this.getTravellerIndex(traveller.id, fields);

    finishScreening((screening, screeningId) => {
      change(`travellers[${key}].screeningSessionId`, screeningId);
      change(`travellers[${key}].screening`, screening);

      this.props.setIsScreening(false);
      this.setState({
        traveller: null,
        sessionId: null,
        isScreening: false,
      });

      this.forceUpdate();
    });
  }

  private renderConditions = (conditions: string[]) => {
    if (conditions.length === 0) {
      return (
        <span className="screened-conditions">No Conditions Screened</span>
      );
    }

    return conditions.map((condition, key) => <li key={key}>{condition}</li>);
  }

  private renderTravellers = (travellerName, key) => {
    const { travellers } = this.props;
    const traveller: ITraveller = travellers[key];
    const hasConditions = !!traveller.screeningSessionId;

    return (
      <div key={key} className="section-group">
        <div className="section">
          <strong>
            {traveller.firstName} {traveller.lastName} {traveller.dob}
          </strong>
        </div>
        <div className="section">
          <Row>
            <Col sm={8}>
              {this.renderConditions(hasConditions ? traveller.screening.meta.conditions : [])}
            </Col>
            <Col sm={4} className="text-right">
              <Button
                bsStyle="primary"
                onClick={this.handleStartScreening(traveller, key)}
                disabled={this.state.loading}
              >
                {hasConditions ? 'Edit' : 'Add'} Conditions
              </Button>
            </Col>
          </Row>
        </div>
      </div>
    );
  }

  private renderHealixScreening = () => {
    const { healix, dispatch } = this.props;
    const { key } = this.state;

    return (
      <div className="traveller-medical" id="traveller-medical">
        <Healix
          index={key}
          screening={healix}
          finishScreening={this.handleFinishScreening}
          dispatch={dispatch}
        />
        <div className="clearfix" />
      </div>
    );
  }

  public render() {
    const { fields } = this.props;
    const { isScreening } = this.state;

    return (
      <div ref={`conditions`}>
        {!isScreening && fields.map(this.renderTravellers)}
        {isScreening && this.renderHealixScreening()}
      </div>
    );
  }
}

let selector;

export default flow([
  (component) => {
    selector = formValueSelector('quote');

    return component;
  },
  connect(
    (state: IStore) => {
      const travellers = selector(state, 'travellers');
      const region = selector(state, 'region');
      const destinations = selector(state, 'destinations');

      return {
        travellers,
        region,
        destinations,
        healix: state.healix,
      };
    },
    (dispatch) => ({
      startScreening: bindActionCreators(startScreening, dispatch),
      finishScreening: bindActionCreators(finishScreening, dispatch),
      dispatch,
    }),
  ),
])(TravellersMedical);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/scenes/Quote/scenes/MedicalDeclaration/components/TravellersMedical/index.tsx